var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import { ToggleSwitch } from '../ToggleSwitch';
import { Checkbox } from '../Checkbox';
import { Radio } from '../Radio';
import { Card } from '../Card';
export class Togglebox extends Component {
    constructor() {
        super(...arguments);
        this.onClickHandler = (e) => {
            if (this.props.onClick) {
                this.props.onClick(this.props.value, e.currentTarget.checked);
                e.currentTarget.focus;
            }
        };
        this.getControl = (control, controlProps) => {
            if (control === 'checkbox')
                return React.createElement(Checkbox, Object.assign({}, controlProps));
            if (control === 'radio')
                return React.createElement(Radio, Object.assign({}, controlProps));
            if (control === 'toggleSwitch') {
                const { error } = controlProps, props = __rest(controlProps, ["error"]);
                return React.createElement(ToggleSwitch, Object.assign({}, props));
            }
        };
        this.getTitle = () => {
            if (this.props.title === undefined || this.props.title === '')
                return;
            return React.createElement("div", { className: "Togglebox__title" }, this.props.title);
        };
        this.getLabel = () => {
            if (this.props.label === undefined || this.props.label === '')
                return;
            return React.createElement("div", { className: "Togglebox__label" }, this.props.label);
        };
    }
    render() {
        const _a = this.props, { checked, className, control = 'checkbox', controlAlign = 'center', disabled, error, id, label, name, onChange, onClick, title, value } = _a, props = __rest(_a, ["checked", "className", "control", "controlAlign", "disabled", "error", "id", "label", "name", "onChange", "onClick", "title", "value"]);
        const toggleboxProps = Object.assign({ checked, disabled, error }, props);
        const uiProps = { checked, disabled, error, name, value, id };
        const ToggleboxClasses = classnames('Togglebox', className, {
            [`Togglebox--${control}`]: control,
            'Togglebox--controlTop': controlAlign === 'top',
        });
        const ContentClasses = classnames('Togglebox__content', {
            'Togglebox__content--title': title,
        });
        return (React.createElement(Card, Object.assign({ active: checked, className: ToggleboxClasses, onClick: this.onClickHandler, raised: checked, sharp: true, thin: true, "data-anvil-component": "Togglebox" }, toggleboxProps),
            React.createElement(Card.Section, null,
                React.createElement("span", { className: ContentClasses },
                    React.createElement("span", { className: "Togglebox__control" }, this.getControl(control, Object.assign({}, uiProps))),
                    React.createElement("span", { className: "Togglebox__children" },
                        this.getTitle(),
                        this.getLabel())))));
    }
}
Togglebox.displayName = 'Togglebox';
//# sourceMappingURL=Togglebox.js.map